<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <span>사용 중지 신청이</span>
                    <span>완료되었습니다.</span>
                </div>
            </div>
          <div @click="closeUsingCancelPopup()">
            <bottom-button :buttonArray="buttonArray"></bottom-button>
          </div>
        </div>
    </div>

</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'StopUsingPopup',
    components: {BottomButton},
    data() {
        return  {
            buttonArray : [
                {
                    className : "button-bg-gray",
                    text : "닫기",
                },
            ],
            barcodeNumber: false,
        }
    },
    props: ["cardInfo"],
    methods : {
        closeUsingCancelPopup() {
            this.$emit('stopUsingPopup', false);
            this.$router.replace({name: 'home', params: { cardInfo: this.cardInfo } })
      }
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/stopUsingPopup.scss';
</style>